module.exports = __webpack_public_path__ + "img/lightbulb-blue.ea462041.png";